export class familia {
    codigo: number;
    nombre: String;
}